<template>
    <div>
        <div id="header">
            <router-link tag="div" :to="{name:'BeautyList'}" id="back-div">
                <img src="../../static/img/back.png" alt="">
            </router-link>
            <div id="tit-div">注册</div>
            <div id="kong-div"> </div>
        </div>
        <div id="content">
            <div class="cont">
                <div class="cont-d">用户名</div>:
                <input type="text" class="name" placeholder="">
            </div>
            <div class="cont">
                <div class="cont-d">密码</div>:
                <input type="password" class="pass" placeholder="">
            </div>
            <div class="cont">
                <div class="cont-d">确认密码</div>:
                <input type="password" class="subpass" placeholder="">
            </div>
            <div id="login" @click="regis">
                注册
            </div>
        </div>
        <div id="mask" v-show="maskShow" @touchmove.prevent>
            <div id="bg" @touchmove.prevent>
                <p class="gongx">两次密码不一致</p>
                    <div class="qr-can">
                    <div class="qr" @click="qr">修改</div>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
import { setTimeout } from 'timers';

export default {
    name:'Regis',
    data(){
        return {
            maskShow:false
        }
    },
    methods: {
        regis:function(){
            let name = $(".name").val();
            let pass = $(".pass").val();
            let sub = $(".subpass").val();
            // console.log(name,pass,sub);
            if(name == '' || pass == '' || sub ==''){
                this.$toast.center('请完善信息！');
            }else if(pass != sub){
                // this.maskShow = true;
                this.$toast.center('两次密码不一致');
            }else{
                let key = 'Girliaefpqp!$TUJi^#@888';
                let t = new Date().getTime();
                let jiami = '';
                function encryptByDESModeEBC(message,key){
                    var keyHex = CryptoJS.enc.Utf8.parse(key); 
                    var encrypted = CryptoJS.DES.encrypt(message, keyHex, { 
                    mode: CryptoJS.mode.ECB, 
                    padding: CryptoJS.pad.Pkcs7 
                    }); 
                    return encrypted.ciphertext.toString(); 
                }
                var source = JSON.stringify({"account":name,"password":pass,})
                var cc = encryptByDESModeEBC(CryptoJS.enc.Utf8.parse(source),key+"_"+t); 
				jiami = cc;
				let apiUrl = process.env.APP_API_URL;
				
				this.$http.get(apiUrl+"/user/reg?data="+jiami+"&t="+t,
				
				).then((response) => {
					// console.log(response);
					if(response.body.status == 1){
                        this.$toast.center('注册成功！');
                        this.$router.push({name:'BeautyList',query:{is_log:1}});
                    }
                    if(response.body.status == -1){
                        this.$toast.center('信息异常！');
                    }
                    if(response.body.status == -2){
                        this.$toast.center('用户已存在！');
                    }
				}).catch((e) => {

				})
            }
        },
        qr:function(){
            $(".subpass").val("");
            this.maskShow = false;
        },
    },
    mounted:function(){

    }
    
}
</script>
<style scoped>
#header{
    padding: 0 .16rem;
    height: .52rem;
    background: #600473;
    display: flex;
	justify-content: space-between;
	align-items: center;
}
#back-div{
    width: .3rem;
}
#back-div img{
    width: .1rem;
}
#tit-div{
    color: #fff;
}
#kong-div{
    height: .3rem;
    width: .3rem;
}
#content{
    padding: .16rem;
}
.cont{
    width: 100%;
    height: .42rem;
    line-height: .42rem;
    display: flex;
    justify-content: space-around;
    border-bottom: 1px solid #e0e0e0;
    color: #53575a;
}

.cont-d {
    width: .8rem;
    text-align:justify;
    text-justify:distribute-all-lines;/*ie6-8*/
    text-align-last:justify;/* ie9*/
    -moz-text-align-last:justify;/*ff*/
    -webkit-text-align-last:justify;/*chrome 20+*/
    font-size: .15rem;
}
@media screen and (-webkit-min-device-pixel-ratio:0){/* chrome*/
    .cont-d:after{
        content:".";
        display: inline-block;
        width:100%;
        overflow:hidden;
        height:0;
    }
}
#login{
    width: 1.6rem;
    height: .32rem;
    text-align: center;
    margin: .4rem auto;
    line-height: .32rem;
    color: #fff;
    background: #600473;
    border-radius:.04rem;
    font-size: .13rem
}
#mask{
    position: fixed;  top: 0%;  left: 0%;  width: 100%;  height: 100%;  background: rgba(16, 16, 16, 0.6);  z-index:1001;
}
#bg{
    width: 2.54rem;
    height: 1.19rem;
    background: #fff;
    background-size: 100% 100%; 
    margin: 2.4rem auto;
    text-align: center;
    border-radius: .03rem;
}
.gongx{
    font-size: .18rem;
    color: #494949;
    padding: .29rem 0rem;
    border-bottom: 1px solid #f5f5f5;
}
.qr-can{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: .16rem;
    margin-top: .04rem;
}
.qr{
    width: 50%;
    color: #e83131;
    border-right: 1px solid #f5f5f5;
}
.cancel{
    width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/view/Register.vue